import React from "react";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core";
import { GoogleIcon } from "../icons";
import palette from "../styles/palette";

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    button: {
      color: palette.typography.black.inactive,
      fontSize: "0.875rem",
      textTransform: "none",
      height: "2.5rem",
      padding: `${pxToRem(6)} ${pxToRem(15)}`,
      maxWidth: pxToRem(200),
    },
    icon: {
      width: "1.125rem",
      height: "1.125rem",
      margin: "0 0.5rem",
    },
    label: {
      fontWeight: 500,
    },
  };
});

export default ({ onClick }) => {
  const styles = useStyles();
  return (
    <Paper>
      <Button
        className={styles.button}
        onClick={onClick}
        startIcon={<GoogleIcon className={styles.icon} />}
        classes={{
          label: styles.label,
        }}
      >
        Sign in with Google
      </Button>
    </Paper>
  );
};
